import { useLocation } from 'react-router-dom';

export const useCompanySelectorVisibility = (
  routesWithQueryParams: {
    path: string;
    queryParams?: { key: string; values: string[] }[];
    matchNestedPaths?: boolean;
  }[],
) => {
  const location = useLocation();
  const pathParts = location.pathname.split('/').filter(Boolean);
  const searchParams = new URLSearchParams(location.search);

  const currentPath = pathParts.join('/');
  const routeMatch = routesWithQueryParams.find(({ path, matchNestedPaths }) => {
    const isExactMatch = currentPath.endsWith(path);
    const isNestedMatch = matchNestedPaths === true && currentPath.startsWith(`${path}/`);

    return isExactMatch || isNestedMatch;
  });

  if (!routeMatch) return false;

  const { queryParams } = routeMatch;

  const queryMatches =
    !queryParams ||
    queryParams.every(({ key, values }) => {
      const paramValue = searchParams.get(key);
      return values.includes(paramValue || '');
    });

  return queryMatches;
};
